import React, { useEffect } from 'react'
import { DeleteFilled, EyeOutlined, FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Col, DatePicker, Flex, Input, Space, Modal, Row, Table, Typography } from 'antd'
import { useSelector } from 'react-redux';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import AuthService from '../../Components/auth/AuthService';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '@mui/material';
import moment from 'moment';
import { netsuite_url } from '../../Components/config';
import { showMessage } from '../../Components/Utils/message';
import dayjs from 'dayjs';
import { encodeId } from '../../Components/common/CommonFun';
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, EXPIRATION_TIME } from '../../Components/common/Constants';
import { styled } from '@mui/system';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService();
const TransactionsPurchaseOrderList = () => {
  const { aisles, locations, products, roles } = useSelector((state) => state?.AppState?.userCreds);
  const firstDatOfMonthDaysJS = dayjs().startOf('month');
  const lastDayOfMonthDaysJS = dayjs().endOf('month');
  const { Text } = Typography;
  const { RangePicker } = DatePicker
  const navigate = useNavigate();
  const layoutDispatch = useLoadingDispatch()
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);
  const [data, setData] = React.useState([]);

  const [filters, setFilters] = React.useState(() => {
    const existing = localStorage.getItem('TransactionPOFilters');
    const parsed = existing ? JSON.parse(existing) : {};
    const currentTime = new Date().getTime();

    const defaultFilters = {
      dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
      batchCode: '',
      page: 1,
    };

    if (parsed.timestamp && currentTime - parsed.timestamp < EXPIRATION_TIME) {
      if (parsed.dateRange) {
        parsed.dateRange = [
          parsed.dateRange[0] ? dayjs(parsed.dateRange[0]) : defaultFilters.dateRange[0],
          parsed.dateRange[1] ? dayjs(parsed.dateRange[1]) : defaultFilters.dateRange[1]
        ];
      }
      return { ...defaultFilters, ...parsed };
    }
    localStorage.removeItem('TransactionPOFilters');
    return defaultFilters;
  });

  const updateFilters = (newValues) => {
    const existingString = localStorage.getItem('TransactionPOFilters');
    const existing = existingString ? JSON.parse(existingString) : {};

    Object.assign(existing, newValues);
    existing.timestamp = new Date().getTime();

    localStorage.setItem('TransactionPOFilters', JSON.stringify(existing));
  };


  const dataCol = [

    {
      title: 'PO Number',
      render: (text, record) => {
        const hasRole5 = roles?.some(r => r.role_id === 5);
        return (
          <>
            {

              hasRole5 ? (
                <>{record.po_number}</>
              ) : (
                <span>
                  <a
                    href={`${netsuite_url}/app/accounting/transactions/purchord.nl?id=${record.internal_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {record.po_number}
                  </a>
                </span>
              )

            }

          </>
        );
      },
    },
    {
      title: 'Receipt No.',
      render: (text, record) => {
        const hasRole5 = roles?.some(r => r.role_id === 5);

        return (
          <>
            {

              hasRole5 ? (
                <>{record.receipt_code}</>
              ) : (
                <span>
                  <a
                    href={`${netsuite_url}/app/accounting/transactions/itemrcpt.nl?id=${record.receipt_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {record.receipt_code}
                  </a>
                </span>
              )

            }

          </>

        );
      },
    },
    {
      title: "Supplier",
      render: (record) => {
        return <span>{record?.supplier_code ? `${record?.supplier_code} - ${record?.supplier_name}` : ""}</span>;
      },
    },
    {
      title: "Received Date",
      render: (record) => {
        return <span>{record?.received_date ? moment(record?.received_date).format("DD-MM-YYYY") : ""}</span>;
      },
    },
    {
      title: "Posting Date",
      render: (record) => {
        return <span>{record?.posting_date ? moment(record?.posting_date).format("DD-MM-YYYY") : ""}</span>;
      },
    },
    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (text, record) => (
        <Flex gap={5} justify='end'>
          {
            record?.posted_by < 1 && (
              <DeleteFilled style={
                {
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#ff0000",
                }} onClick={() => {
                  Modal.confirm({
                    title: 'Delete Transaction',
                    centered: true,
                    content: `Are you sure? Deleting this will permanently remove all data associated with the purchase order.`,
                    onOk: () => deleteTransaction(record),
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large" },
                    cancelButtonProps: { size: "large" },
                  });
                }}
              />
            )
          }

          <EyeOutlined
            style={{
              fontSize: "25px",
              cursor: "pointer",
              marginRight: "5px",
              color: "#006cb8",
            }} onClick={() => {
              const hasedID = encodeId(record?.id)

              navigate(`/transaction-po/${hasedID}`)
            }} />

        </Flex>
      )
    },

  ];

  const deleteTransaction = async (record) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/delete-po`, {
        method: "DELETE",
        body: JSON.stringify({ po_number: record?.po_number })

      });
      if (res?.ack) {
        getTransactionData();
        showMessage('success', res?.message);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };
  const getTransactionData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      limit: limit,
      page: filters.page,
    }
    if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
      dataToSend.start_date = dayjs(filters?.dateRange[0]).format(DEFAULT_DATE_FORMAT);
      dataToSend.end_date = dayjs(filters?.dateRange[1]).format(DEFAULT_DATE_FORMAT);
    }
    if (filters?.batchCode) {
      dataToSend.searchText = (filters?.batchCode || '').trim();
    }
    try {
      const res = await Auth.post(`/stock/purchase-orders`, dataToSend)
      if (res.ack) {
        setData(res?.purchase_orders);
        setTotalPages(Math.ceil(res.total_count / limit));
        setTotalCount(res.total_count);
      } else {
        showMessage('error', res.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  useEffect(() => {
    const timeOutId = setTimeout(() => getTransactionData(), 100);
    return () => clearTimeout(timeOutId);
  }, [filters?.page, filters?.dateRange]);

  const handleChange = (event, value) => {
    setFilters(prev => ({ ...prev, page: value }));
    updateFilters({ page: value });
    setPageChange(true)
  };

  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Purchase Orders</>} style={{ marginBottom: '10px' }}>
        <Row gutter={[6, 1]}>
          <Col xs={24} md={12} lg={8}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
            <RangePicker
              style={{ width: '100%' }}
              value={filters.dateRange}
              onChange={(dates) => {
                setFilters(prev => ({ ...prev, dateRange: dates, page: 1 }));
                updateFilters({ 
                  dateRange: dates ? [dates[0] ? dates[0].format(DEFAULT_DATE_FORMAT) : null, dates[1] ? dates[1].format(DEFAULT_DATE_FORMAT) : null] : null,
                  page: 1 
                });
              }}
              format={DATE_FORMAT}
              allowClear={false}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Search</label>
            <Input
              placeholder="Search"
              value={filters.batchCode}
              onChange={(e) => {
                const val = e.target.value;
                setFilters(prev => ({ ...prev, batchCode: val, page: 1 }));
                updateFilters({ batchCode: val, page: 1 });
              }}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Space style={{ width: '100%', marginTop: '25px' }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => getTransactionData()}
              >
                Search
              </Button>
            </Space>
          </Col>

        </Row>
      </Card>
      <Table
        columns={dataCol}
        dataSource={data}
        pagination={false}
        scroll={{ x: "max-content" }}
        style={{ marginTop: "10px" }}
        footer={() => {
          const startRecord = (filters.page - 1) * limit + 1;
          const endRecord = Math.min(filters.page * limit, data?.length ? totalCount : 0);
          return `Showing ${startRecord}-${endRecord} of ${data?.length ? totalCount : "0"} Records`;
        }}
        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
      />
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={filters.page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
    </DataSheet>
  )
}

export default TransactionsPurchaseOrderList
